import { Component } from '@angular/core';


export class TextInputAutocompleteContainerComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mwl-text-input-autocomplete-container',
  styles: [
    `
    :host {
      position: relative;
      display: block;
    }
  `
  ],
  template: '<ng-content></ng-content>'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
